import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const TaxService = {
    getTaxDetailsByTimePeriod: async (startDate, endDate) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/timePeriod?startDate=${startDate}&endDate=${endDate}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getTaxDetailsByYear: async (year) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/annual/${year}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getTaxDetailsByBooking: async (bookingNumber) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/booking/${bookingNumber}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getWalletTaxDetailsByTimePeriod: async (startDate, endDate) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/wallet/timePeriod?startDate=${startDate}&endDate=${endDate}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getWalletTaxDetailsByYear: async (year) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/wallet/annual/${year}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getWalletTaxDetailsByExpertId: async (expertId, startDate, endDate) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/wallet/expert/${expertId}?startDate=${startDate}&endDate=${endDate}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },
};
